import React from 'react';
import './Industries.css';
import { usePageTitle } from '../hooks/usePageTitle';

function Industries() {
  usePageTitle('Industries We Serve');
  return (
    <div className="industries">
      <section className="industries-hero">
        <div className="industries-container">
          <h1 className="industries-hero-title">Industries We Serve</h1>
          <p className="industries-hero-subtitle">Tailored AI and software solutions for your industry</p>
        </div>
      </section>

      <section className="industries-main">
        <div className="industries-container">
          <div className="industry-section">
            <div className="industry-header">
              <h2>🏭 Manufacturing</h2>
            </div>
            <div className="industry-content">
              <div className="industry-problems">
                <h3>Business Challenges</h3>
                <ul>
                  <li>Quality control defects</li>
                  <li>Production downtime</li>
                  <li>Manual inspection costs</li>
                  <li>Supply chain inefficiencies</li>
                </ul>
              </div>
              <div className="industry-solutions">
                <h3>Our AI Solutions</h3>
                <ul>
                  <li>Computer vision defect detection (95% accuracy)</li>
                  <li>Predictive maintenance systems</li>
                  <li>Automated quality inspection</li>
                  <li>Supply chain optimization AI</li>
                  <li>Production monitoring dashboards</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="industry-section">
            <div className="industry-header">
              <h2>🏥 Healthcare & MedTech</h2>
            </div>
            <div className="industry-content">
              <div className="industry-problems">
                <h3>Business Challenges</h3>
                <ul>
                  <li>Patient data management</li>
                  <li>Appointment scheduling</li>
                  <li>Medical record processing</li>
                  <li>Compliance requirements</li>
                </ul>
              </div>
              <div className="industry-solutions">
                <h3>Our AI Solutions</h3>
                <ul>
                  <li>Medical document intelligence</li>
                  <li>AI appointment scheduling</li>
                  <li>Patient engagement chatbots</li>
                  <li>HIPAA-compliant systems</li>
                  <li>Telemedicine platforms</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="industry-section">
            <div className="industry-header">
              <h2>💪 Fitness & Retail</h2>
            </div>
            <div className="industry-content">
              <div className="industry-problems">
                <h3>Business Challenges</h3>
                <ul>
                  <li>Member retention</li>
                  <li>Personalization at scale</li>
                  <li>Customer engagement</li>
                  <li>Inventory management</li>
                </ul>
              </div>
              <div className="industry-solutions">
                <h3>Our AI Solutions</h3>
                <ul>
                  <li>AI-driven personalization (45% retention boost)</li>
                  <li>Automated member engagement</li>
                  <li>Smart recommendation engines</li>
                  <li>Inventory optimization AI</li>
                  <li>Mobile fitness apps</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="industry-section">
            <div className="industry-header">
              <h2>🚀 Startups & SaaS</h2>
            </div>
            <div className="industry-content">
              <div className="industry-problems">
                <h3>Business Challenges</h3>
                <ul>
                  <li>Fast time-to-market</li>
                  <li>Limited engineering resources</li>
                  <li>Scalability concerns</li>
                  <li>Product-market fit</li>
                </ul>
              </div>
              <div className="industry-solutions">
                <h3>Our AI Solutions</h3>
                <ul>
                  <li>MVP development in 8-12 weeks</li>
                  <li>Dedicated engineering teams</li>
                  <li>Cloud-native architecture</li>
                  <li>AI feature integration</li>
                  <li>Product strategy consulting</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="industry-section">
            <div className="industry-header">
              <h2>📦 Logistics & Warehousing</h2>
            </div>
            <div className="industry-content">
              <div className="industry-problems">
                <h3>Business Challenges</h3>
                <ul>
                  <li>Route optimization</li>
                  <li>Warehouse efficiency</li>
                  <li>Demand forecasting</li>
                  <li>Real-time tracking</li>
                </ul>
              </div>
              <div className="industry-solutions">
                <h3>Our AI Solutions</h3>
                <ul>
                  <li>AI route optimization</li>
                  <li>Warehouse automation systems</li>
                  <li>Demand prediction models</li>
                  <li>Real-time tracking platforms</li>
                  <li>Inventory management AI</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Industries;
